"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BankAccountsItem = void 0;
const AccountHolder_1 = require("./bankaccounts/AccountHolder");
const AccountNumber_1 = require("./bankaccounts/AccountNumber");
const AccountType_1 = require("./bankaccounts/AccountType");
const Bic_1 = require("./bankaccounts/Bic");
const Currency_1 = require("./bankaccounts/Currency");
const Iban_1 = require("./bankaccounts/Iban");
const IsDefault_1 = require("./bankaccounts/IsDefault");
const RoutingNumber_1 = require("./bankaccounts/RoutingNumber");
exports.BankAccountsItem = {
    account_holder: AccountHolder_1.AccountHolder,
    account_number: AccountNumber_1.AccountNumber,
    account_type: AccountType_1.AccountType,
    bic: Bic_1.Bic,
    currency: Currency_1.Currency,
    iban: Iban_1.Iban,
    is_default: IsDefault_1.IsDefault,
    routing_number: RoutingNumber_1.RoutingNumber,
};
